import { useSelector } from 'react-redux';
import { selectIsMoneySourceWidgetVisibleInPromotionWrapper } from '../../../../../selectors/elementsVisibility';
import {
  selectDisablePromotionSection,
  selectIsDisabledPromotion,
  selectIsWithoutServices,
} from '../../../../../selectors/publishTerms';
import { selectCompetitorsExperiment } from '../../../../../selectors/experiments';

export const usePromotionLayout = () => {
  const showMoneySourceWidget = useSelector(selectIsMoneySourceWidgetVisibleInPromotionWrapper);
  const isWithoutServices = useSelector(selectIsWithoutServices);
  const isPromotionDisabled = useSelector(selectIsDisabledPromotion);
  const blurDisabledServices = useSelector(selectDisablePromotionSection);
  const inCompetitorsExperiment = useSelector(selectCompetitorsExperiment);

  const showNoServicesScreen =
    (isWithoutServices || isPromotionDisabled) && !blurDisabledServices && !inCompetitorsExperiment;

  return {
    showMoneySourceWidget,
    showNoServicesScreen,
  };
};
